import type { ShellKind } from '@web/theme/theme';

export type { ShellKind } from '@web/theme/theme';

/** The application has a single web shell: the admin app, served under `/admin` (or on an `admin.` host). */
export const SHELLS: readonly ShellKind[] = ['admin'];

export interface ShellResolution {
  shell: ShellKind;
  /** Router basename: '' when chosen by host name, '/admin' when chosen by path. */
  basename: string;
  mode: 'host' | 'path';
  /** Set when the current URL must be rewritten (e.g. `/` → `/admin/`, `/activate` → `/admin/activate`). */
  rewriteTo?: string;
}

function isShell(v: string | undefined): v is ShellKind {
  return !!v && (SHELLS as readonly string[]).includes(v);
}

/**
 * Picks the shell: an `admin.` host prefix serves the app at the root; otherwise the app lives
 * under `/admin` and every other path (including the former `/ops`, `/me`, `/portal` shells)
 * is rewritten below it.
 */
export function resolveShell(hostname: string, pathname: string): ShellResolution {
  const labels = hostname.toLowerCase().split('.');
  if (labels.length > 1 && isShell(labels[0])) return { shell: labels[0], basename: '', mode: 'host' };
  const seg = pathname.split('/')[1]?.toLowerCase();
  if (isShell(seg)) return { shell: seg, basename: `/${seg}`, mode: 'path' };
  const rest = pathname === '/' || pathname === '' ? '/' : pathname;
  return { shell: 'admin', basename: '/admin', mode: 'path', rewriteTo: `/admin${rest}` };
}
